<template>
  <div>
    <DxForm id="formularioDelegacionInmobiliaria" ref="formInstance" :form-data="model" label-location="top"
      :show-colon-after-label="false" :visible="model != null" validation-group="validacionDelegacionInmobiliaria">
      <!-- xs: 768, sm: 992, md:1200 -->
      <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />

      <!-- Datos de la delegación -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem data-field="Nombre" editor-type="dxTextBox" :col-span="6">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.nombre')" />
          <DxRequiredRule :message="$t('delegacion_inmobiliaria.form.validacion.nombre')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Descripcion" editor-type="dxTextBox" :col-span="6">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.descripcion')" />
          <DxRequiredRule :message="$t('delegacion_inmobiliaria.form.validacion.descripcion')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Telefono" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.telefono')" />
          <DxRequiredRule :message="$t('delegacion_inmobiliaria.form.validacion.telefono')" />
          <DxPatternRule :pattern="telefonoPattern"
            :message="$t('delegacion_inmobiliaria.form.validacion.telefono_patron')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Email" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.email')" />
          <DxRequiredRule :message="$t('delegacion_inmobiliaria.form.validacion.email')" />
          <DxEmailRule :message="$t('delegacion_inmobiliaria.form.validacion.email_patron')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Web" editor-type="dxTextBox" :col-span="6">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.sitio_web')" />
          <DxRequiredRule :message="$t('delegacion_inmobiliaria.form.validacion.sitio_web')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Coordinadores" editor-type="dxTagBox" :col-span="6"
          :editor-options="{ ...getCoordinadoresProperties(), ...selectCoordinadoresOptions }">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.coordinadores')" />
        </DxSimpleItem>
      </DxGroupItem>

      <!-- Dirección física -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem :col-span="6">
          <span class="dx-field-item-label-text text-success">{{
            $t("delegacion_inmobiliaria.form.direccion_fisica")}}</span>
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.CodigoPostal" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.codigo_postal')" />
          <DxRequiredRule :message="$t('delegacion_inmobiliaria.form.validacion.codigo_postal')" />
          <DxPatternRule :pattern="codigoPostalPattern"
            :message="$t('delegacion_inmobiliaria.form.validacion.codigo_postal_patron')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Provincia" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.provincia')" />
          <DxRequiredRule :message="$t('delegacion_inmobiliaria.form.validacion.provincia')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Municipio" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.municipio')" />
          <DxRequiredRule :message="$t('delegacion_inmobiliaria.form.validacion.municipio')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.TipoVia" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.tipo_de_via')" />
          <DxRequiredRule :message="$t('delegacion_inmobiliaria.form.validacion.tipo_de_via')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.NombreVia" editor-type="dxTextBox" :col-span="4">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.nombre_via')" />
          <DxRequiredRule :message="$t('delegacion_inmobiliaria.form.validacion.nombre_via')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Numero" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.numero')" />
          <DxRequiredRule :message="$t('delegacion_inmobiliaria.form.validacion.numero')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Escalera" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.escalera')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Piso" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.piso')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Puerta" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('delegacion_inmobiliaria.form.puerta')" />
        </DxSimpleItem>
        <DxEmptyItem :col-span="2">
        </DxEmptyItem>
      </DxGroupItem>
    </DxForm>
  </div>
</template>

<script setup lang="ts">
import { useIntl } from '@services/i18n';
import { useApi } from '@api/integration';
import { DxTagBox, type DxButton } from 'devextreme-vue';
import validationEngine from "devextreme/ui/validation_engine";
import { messageBoxResult } from '@components/dialogs/message-box';
import { getCurrentInstance, onBeforeMount, onMounted, reactive, ref } from 'vue';
import { toastError, toastSuccess } from '@/.shared/services/notification-service';
import { useModalBuilder, type ToolbarReference } from '@helpers/modal-building-helper';
import { type CreateDelegacionInmobiliariaModel, type EditDelegacionInmobiliariaModel } from '@api/api';
import {
  DxEmailRule,
  DxForm,
  DxLabel,
  DxColCountByScreen,
  DxRequiredRule,
  DxPatternRule,
  DxEmptyItem,
  DxSimpleItem,
  DxGroupItem
} from "devextreme-vue/form";

const props = defineProps({
  model: {
    type: Object as () => CreateDelegacionInmobiliariaModel,
    required: true
  },
  isEditMode: {
    type: Boolean,
    required: true
  }
});

const api = useApi();
const intl = useIntl();

const formInstance = ref<DxForm>();
const telefonoPattern = ref<RegExp>(/^\d{9}$/);
const codigoPostalPattern = ref<RegExp>(/^\d{5}$/);
const selectCoordinadoresOptions = reactive<any>({});

onBeforeMount(async () => {
  selectCoordinadoresOptions.dataSource = await api.callStandardApi("getCoordinadoresDelegacionSelector", { showLoading: false }, props.model.IdEmpresaInmobiliaria);
});

onMounted(async () => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!)
  configureButtons(modal);
});

function getCoordinadoresProperties(): DxTagBox {
  return {
    valueExpr: 'Id',
    displayExpr: 'Denominacion',
    searchEnabled: true
  }
}

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
  let okButton: ToolbarReference<DxButton>;
  let cancelButton: ToolbarReference<DxButton>;
  ({ okButton, cancelButton } = modal.standardButtons.addOkCancel());
  okButton.update(w => w.text = `${intl.i18n.t("shared.ui.buttons.save")}`);
  okButton.update(w => w.onClick = async () => {
    saveOrEdit().then((value) => {
      if (value)
        modal.close(messageBoxResult.ok)
    });
  }
  );
  cancelButton.update(w => w.onClick = () => modal.close(messageBoxResult.cancel));
}

const saveOrEdit = async () => {
  var res = validationEngine.validateGroup("validacionDelegacionInmobiliaria");
  if (res.isValid) {
    if (props.isEditMode) {
      await api.callStandardApi("editDelegacionInmobiliaria", { showLoading: true }, props.model as EditDelegacionInmobiliariaModel)
        .then(() => toastSuccess(intl.i18n.t('delegacion_inmobiliaria.edicion_exito')))
        .catch(() => {
          toastError(intl.i18n.t('delegacion_inmobiliaria.edicion_fallo'));
          return false;
        });
    } else {
      await api.callStandardApi("createDelegacionInmobiliaria", { showLoading: true }, props.model as CreateDelegacionInmobiliariaModel)
        .then(() => toastSuccess(intl.i18n.t('delegacion_inmobiliaria.creacion_exito')))
        .catch(() => {
          toastError(intl.i18n.t('delegacion_inmobiliaria.creacion_fallo'));
          return false;
        });
    }
    return true;
  } else {
    toastError(intl.i18n.t('delegacion_inmobiliaria.revise_validacion'));
  }
  return false;
}
</script>

<style scoped lang="scss">


.info-icon {
  margin-left: auto;
  font-size: 14px;
  cursor: pointer;
  position: relative;
}

.tooltip {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--background-normal-dark);
  color: white;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>